import React, { useEffect } from 'react';
import Container from 'reactstrap/es/Container';
import { isEmpty, isFunction } from 'lodash';
import { connect } from 'react-redux';
import axios from 'axios';
import Table from 'reactstrap/es/Table';
import { formatDate } from '../../helper';
import { Loading } from '../../components';

const ContestDetailPage = ({ data, onMount, match }) => {
  useEffect(() => {
    let id = match?.params?.id;
    if (isFunction(onMount)) onMount(id);
  }, []);

  if (isEmpty(data)) return <Loading />;

  return (
    <Container fluid className='pt-3 px-lg-5'>
      <span className='h2 text-primary text-uppercase'>{data.name}</span>
      {data?.files?.length ? null : <p>Không tìm thấy thông tin</p>}
      {data?.files?.map((f) => (
        <div key={f.id} className='mt-3'>
          <p>Cập nhật ngày {formatDate(f.updatedDate)}</p>
          <Table>
            <thead>
              <tr>
                {f?.columnHeaders?.map((h, i) => (
                  <th key={`${h}_${i}`} className='text-nowrap'>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {f?.data?.map((d) => (
                <tr key={d.id}>
                  {d?.content?.slice(0, f.columnHeaders?.length || 0).map((c, i) => (
                    <td key={i} className='text-nowrap'>
                      {c}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ))}
    </Container>
  );
};

export const FETCH_CONTEST_START = 'fetch_contest_start';
export const FETCH_CONTEST_SUCCESS = 'fetch_contest_success';
export const FETCH_CONTEST_ERROR = 'fetch_contest_error';

const loadContest = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CONTEST_START, payload: id });
    let res = await axios.get(`/api/contests/${id}`);
    dispatch({ type: FETCH_CONTEST_SUCCESS, payload: res?.data });
  } catch (err) {
    dispatch({ type: FETCH_CONTEST_ERROR, payload: err });
  }
};

const mapStateToProps = (state, props) => {
  const id = props?.match?.params?.id;
  const data = state?.contest?.byId?.[id];
  return { data };
};

const mapDispatchToProps = { onMount: loadContest };

export default connect(mapStateToProps, mapDispatchToProps)(ContestDetailPage);
